import { render } from "./CommentModal.vue?vue&type=template&id=8d9d5122"
import script from "./CommentModal.vue?vue&type=script&lang=js"
export * from "./CommentModal.vue?vue&type=script&lang=js"

import "./CommentModal.vue?vue&type=style&index=0&id=8d9d5122&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__